// src/sentry.js
// Initialisation du suivi d'erreurs (Sentry). Activé uniquement si un DSN est
// fourni via REACT_APP_SENTRY_DSN → en local (sans DSN) Sentry reste silencieux,
// on ne pollue pas le dashboard avec les erreurs de développement.
// Vie privée : sendDefaultPii=false → pas d'envoi d'IP ni de données perso.
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
    Sentry.init({
        dsn,
        environment: process.env.NODE_ENV || "production",
        sendDefaultPii: false,
        // Suivi des erreurs uniquement (pas de traces de perf ni de session replay,
        // pour rester léger et respectueux de la vie privée).
        tracesSampleRate: 0,
    });
}

export default Sentry;
